import React from "react";

import { ImportHexDialogContents } from "./ImportHexDialogContents.js";

export const ImportNewComponentDialog: React.ComponentType = React.memo(
  function ImportNewComponentDialog() {
    return <ImportHexDialogContents dialog="component-import" />;
  },
);
